import {
  CurrencyDollarIcon,
  CurrencyPoundIcon,
  CurrencyEuroIcon,
} from '@paypalcorp/pp-react'
import { ImageConfiguration } from '../../../../typings'

export function getCurrencyElements(currentUserCountryCode: string) {
  const fallbackCurrencyElements = {
    CurrencyComponent: CurrencyEuroIcon,
    currencyDataTestId: 'euroIcon',
  }
  const currencyElements = {
    US: {
      CurrencyComponent: CurrencyDollarIcon,
      currencyDataTestId: 'dollarIcon',
    },
    GB: {
      CurrencyComponent: CurrencyPoundIcon,
      currencyDataTestId: 'poundIcon',
    },
  }
  return (
    currencyElements[currentUserCountryCode as keyof typeof currencyElements] ||
    fallbackCurrencyElements
  )
}

export const getImageSrcSet = (
  baseDirectory: string,
  images: ImageConfiguration,
): string =>
  Object.keys(images)
    .map(
      (value) =>
        `${baseDirectory}${images[value as keyof typeof images]} ${value}`,
    )
    .join(', ')
